import { AppBrandDisplayNameEnum, AppBrands, BrandEnum, NavigationBrands, ServiceBrands } from '../constants.js'

class brandUtil {
  static getAppBrandByBrandName = (brandName) => {
    switch (brandName.toLowerCase()) {
      case AppBrandDisplayNameEnum.c1l.toLowerCase():
        return AppBrands.c1l

      case AppBrandDisplayNameEnum.ccc.toLowerCase():
        return AppBrands.ccc

      case AppBrandDisplayNameEnum.ccf.toLowerCase():
        return AppBrands.ccf

      case AppBrandDisplayNameEnum.chs.toLowerCase():
      case AppBrandDisplayNameEnum.chs2.toLowerCase():
        return AppBrands.chs

      case AppBrandDisplayNameEnum.cic.toLowerCase():
        return AppBrands.cic

      case AppBrandDisplayNameEnum.esm.toLowerCase():
      case AppBrandDisplayNameEnum.esmName.toLowerCase():
        return AppBrands.esm

      case AppBrandDisplayNameEnum.inl.toLowerCase():
        return AppBrands.inl

      case AppBrandDisplayNameEnum.rpc.toLowerCase():
        return AppBrands.rpc

      case AppBrandDisplayNameEnum.spc.toLowerCase():
        return AppBrands.spc

      case AppBrandDisplayNameEnum.tbs.toLowerCase():
        return AppBrands.tbs

      case AppBrandDisplayNameEnum.tmx.toLowerCase():
        return AppBrands.tmx

      default:
        return process.env.VUE_APP_AppBrand || AppBrands.tmx
    }
  }

  static getNavigationBrandByAppBrand = (appBrand) => {
    switch (appBrand.toLowerCase()) {
      case AppBrands.c1l:
        return NavigationBrands.Cash1Loans

      case AppBrands.ccc:
        return NavigationBrands.CaliforniaCheckCash

      case AppBrands.ccf:
        return NavigationBrands.CommunityChoice

      case AppBrands.chs:
        return NavigationBrands.CheckSmart

      case AppBrands.cic:
        return NavigationBrands.CheckIntoCash

      case AppBrands.esm:
        return NavigationBrands.EasyMoney

      case AppBrands.inl:
        return NavigationBrands.InstaLoan

      case AppBrands.rpc:
        return NavigationBrands.RapidCash

      case AppBrands.spc:
        return NavigationBrands.SpeedyCash

      case AppBrands.tbs:
        return NavigationBrands.TitleBucks

      case AppBrands.tmx:
        return NavigationBrands.TitleMax
    }
  }

  static getNavigationBrandByServiceBrand = (appBrand) => {
    switch (appBrand.toLowerCase()) {
      case ServiceBrands.Cash1Loans:
        return NavigationBrands.Cash1Loans

      case ServiceBrands.CaliforniaCheckCash:
        return NavigationBrands.CaliforniaCheckCash

      case ServiceBrands.CommunityChoice:
        return NavigationBrands.CommunityChoice

      case ServiceBrands.CheckSmart:
        return NavigationBrands.CheckSmart

      case ServiceBrands.CheckIntoCash:
        return NavigationBrands.CheckIntoCash

      case ServiceBrands.EasyMoney:
        return NavigationBrands.EasyMoney

      case ServiceBrands.InstaLoan:
        return NavigationBrands.InstaLoan

      case ServiceBrands.RapidCash:
        return NavigationBrands.RapidCash

      case ServiceBrands.SpeedyCash:
        return NavigationBrands.SpeedyCash

      case ServiceBrands.TitleBucks:
        return NavigationBrands.TitleBucks

      case ServiceBrands.TitleMax:
        return NavigationBrands.TitleMax
    }
  }

  static getAppBrandByRouteBrand (routeBrand) {
    switch (routeBrand) {
      case BrandEnum.Cash1Loans:
        return AppBrands.c1l

      case BrandEnum.CaliforniaCheckCash:
        return AppBrands.ccc

      case BrandEnum.CommunityChoice:
        return AppBrands.ccf

      case BrandEnum.CheckSmart:
        return AppBrands.chs

      case BrandEnum.CheckIntoCash:
        return AppBrands.cic

      case BrandEnum.EasyMoney:
        return AppBrands.esm

      case BrandEnum.InstaLoan:
        return AppBrands.inl

      case BrandEnum.TitleBucks:
        return AppBrands.tbs

      case BrandEnum.TitleMax:
        return AppBrands.tmx
    }
  }

  static getBrandByAppBrand = (appBrand) => {
    switch (appBrand.toLowerCase()) {
      case AppBrands.c1l:
        return AppBrandDisplayNameEnum.c1l

      case AppBrands.ccc:
        return AppBrandDisplayNameEnum.ccc

      case AppBrands.ccf:
        return AppBrandDisplayNameEnum.ccf

      case AppBrands.chs:
        return AppBrandDisplayNameEnum.chs

      case AppBrands.cic:
        return AppBrandDisplayNameEnum.cic

      case AppBrands.esm:
        return AppBrandDisplayNameEnum.esm

      case AppBrands.inl:
        return AppBrandDisplayNameEnum.inl

      case AppBrands.rpc:
        return AppBrandDisplayNameEnum.rpc

      case AppBrands.spc:
        return AppBrandDisplayNameEnum.spc

      case AppBrands.tbs:
        return AppBrandDisplayNameEnum.tbs

      case AppBrands.tmx:
        return AppBrandDisplayNameEnum.tmx

      default:
        return process.env.VUE_APP_AppBrand || AppBrands.tmx
    }
  }
}

export default brandUtil
